<template>
  <div>
    <el-button @click="dialogVisible = true">基本设置</el-button>
    <el-dialog
      :visible="dialogVisible"
      title="开关设置"
      width="1000px"
      @close="closeDialog"
    >
      <el-form ref="form" label-width="140px">
        <el-form-item label="开启单笔转账：" prop="valueOne">
          <el-switch v-model="valueOne" @change="turnOne"></el-switch>
        </el-form-item>
        <el-form-item label="开启批量转账：" prop="values">
          <el-switch v-model="values" @change="turnSome"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Editor from 'components/editor';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';

export default {
  name: 'purchaseCreate',
  data() {
    return {
      dialogVisible: false,
      valueOne: false,
      values: false
    };
  },
  components: {},
  computed: {
    ...mapState('purchaseProject', ['coinTypeList', 'languageList'])
  },
  methods: {
    ...mapActions('purchaseProject', [
      'getOneButton',
      'getSomeButton',
      'setOneButton',
      'setSomeButton'
    ]),
    closeDialog() {
      this.dialogVisible = false;
      this.$refs['form'].resetFields();
    },
    turnOne() {
      this.setOneButton({ button: this.valueOne }).then(() => {
        this.$message({
          message: '操作成功！',
          type: 'success'
        });
      });
    },
    turnSome() {
      this.setSomeButton({ button: this.values }).then(() => {
        this.$message({
          message: '操作成功！',
          type: 'success'
        });
      });
    }
  },
  mounted() {
    this.getOneButton().then(res => {
      this.valueOne = res.data;
    });
    this.getSomeButton().then(res => {
      this.values = res.data;
    });
  }
};
</script>
<style lang="less"></style>
